export const isProduction = import.meta.env.MODE === 'production';

export const keyMapMetadata: Record<string, string> = {
  category: 'Thư mục gốc',
  fileName: 'Tên tệp',
  fullPath: 'Đường dẫn đầy đủ',
  createAt: 'Ngày tạo',
  creator: 'Người tạo',
  creatorId: 'ID người tạo',
  DataSource: 'Nguồn dữ liệu',
  SuggestedAICategories: 'Danh mục AI gợi ý',
  KeywordAISuggestion: 'Từ khóa AI gợi ý',
  SummaryOfSuggestedAI: 'Tóm tắt AI gợi ý',
  AccessLevel: 'Cấp độ truy cập',
  path: 'Đường dẫn',
  summary: 'Trích yếu',
  effectiveDate: 'Ngày hiệu lực',
  expirationDate: 'Ngày hết hiệu lực',
  issueDate: 'Ngày ban hành',
  processingStatus: 'Trạng thái xử lý',
  status: 'Tình trạng',
  modifier: 'Người sửa',
  modifiedDate: 'Ngày sửa',
  version: 'Phiên bản',
  documentType: 'Loại văn bản',
  field: 'Lĩnh vực',
  dataSource: 'Nguồn dữ liệu',
};

export const isTextarea = (key: string) => {
  if (
    key === 'SummaryOfSuggestedAI' ||
    key === 'KeywordAISuggestion' ||
    key === 'SuggestedAICategories'
  ) {
    return true;
  }

  return false;
};

export const isDisableField = (key: string) => {
  if (
    key === 'fullPath' ||
    key === 'createAt' ||
    key === 'creator' ||
    key === 'creatorId' ||
    key === 'DataSource' ||
    key === 'AccessLevel' ||
    key === 'category' ||
    key === 'fileName' ||
    key === 'version'
  ) {
    return true;
  }

  return false;
};

// Giới hạn kích thước upload: mỗi file tối đa 50MB VÀ tổng dung lượng mỗi lần
// upload tối đa 50MB. Trả về `true` nếu vi phạm (kèm toast lỗi) để phía gọi dừng lại.
export const MAX_UPLOAD_FILE_SIZE = 50 * 1024 * 1024;
export const MAX_UPLOAD_TOTAL_SIZE = 50 * 1024 * 1024;

export const checkConditionUploadFiles = (files: FileList, toast: any) => {
  const fileArray = Array.from(files);

  // Kiểm tra từng file vượt quá 50MB
  const oversizedFiles = fileArray.filter((file) => file && file.size > MAX_UPLOAD_FILE_SIZE);
  if (oversizedFiles.length > 0) {
    toast({
      title: 'Lỗi tải lên',
      description: `Tệp ${oversizedFiles
        .map((file) => file.name)
        .join(', ')} vượt quá giới hạn kích thước 50MB.`,
      variant: 'destructive',
    });
    return true;
  }

  // Kiểm tra tổng dung lượng cả lần upload vượt quá 50MB
  const totalSize = fileArray.reduce((acc, file) => acc + (file?.size ?? 0), 0);
  if (totalSize > MAX_UPLOAD_TOTAL_SIZE) {
    toast({
      title: 'Lỗi tải lên',
      description: 'Tổng dung lượng các tập tin vượt quá giới hạn 50MB.',
      variant: 'destructive',
    });
    return true;
  }

  return false;
};

// Map sync status from English to Vietnamese
export const syncStatusMap: Record<string, string> = {
  STARTING: 'Đang bắt đầu',
  IN_PROGRESS: 'Đang đồng bộ',
  COMPLETE: 'Đồng bộ thành công',
  FAILED: 'Đồng bộ thất bại',
  STOPPING: 'Đang dừng',
  STOPPED: 'Đã dừng',
};

export const getSyncStatusInVietnamese = (status: string): string => {
  return syncStatusMap[status] || status;
};
